import { isDev } from "../../wallet_generic/helpers/isDev";

export async function getAddressUSDC() {
    if(isDev()) {
        return "0xB98a692f5bb299278ca45A87BB415d9eB0A878a0";
    }
    return "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d";
}